import { render, staticRenderFns } from "./AddColorExistingEdit.vue?vue&type=template&id=7823fb2d&scoped=true"
import script from "./AddColorExistingEdit.vue?vue&type=script&lang=js"
export * from "./AddColorExistingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823fb2d",
  null
  
)

export default component.exports